// extracted by mini-css-extract-plugin
export default {"container":"Warning_Control_container__UAwnL","icon":"Warning_Control_icon__4U8dK","priority":"Warning_Control_priority__LpLn9","critical":"Warning_Control_critical__oydFc"};